import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-multinivel',
  templateUrl: './multinivel.component.html',
  styleUrls: ['./multinivel.component.scss'],
})
export class MultinivelComponent implements OnInit {
  public buttons = [
    {
      value: 'create',
      name: 'Crear'
    },
    {
      value: '3',
      name: 'Gerente'
    },
    {
      value: '2',
      name: 'Supervisor'
    },
    {
      value: '1',
      name: 'Vendedor'
    },
    {
      value: '0',
      name: 'Afiliado'
    },
  ]

  public segmentValue = { value: 'create', name: 'Crear' };

  constructor(
  ) { }

  ngOnInit(): void {
    
  }

  segmentChanged(ev){
    this.segmentValue = this.buttons.find(x => x.value === ev.detail.value);
  }

}
